// Debugging confirmation
console.log('✅  Page Builder buildContentContactUs loaded successfully!');

export async function buildContentContactUs() {
  console.log(`🏗️ buildContentContactUs Page Builder - Starting Building Page`);

  try {
    // Parallel import of all dependencies
    const [
      { buildMasterPageByMasterLayoutBuildManager },
      { buildComponentPageContactUs, buildComponentPageContactUsHeaderTags },
    ] = await Promise.all([
      import(/* webpackChunkName:"master-pages" */ '../js/build-manager-master-pages.js'),
      import(
        /* webpackChunkName:"page-ContactUs"*/ '../builders-components/other-pages/contact-us.js'
      ),
    ]);

    // 2. Build layouts in parallel
    const [masterLayout, pageComponent, pageHeaderTags] = await Promise.all([
      buildMasterPageByMasterLayoutBuildManager('master-layout-light'),
      buildComponentPageContactUs(),
      buildComponentPageContactUsHeaderTags(),
    ]);

    // Insert component into page layout

    const masterLayoutX = `<div id="x-my-page-layout">${masterLayout}</div>`;
    const pageContentX = `<div id="x-my-page-content">${pageComponent}</div>`;

    console.log(`🔄 buildContentContactUs Builder - Finished (Client-side)`);
    return {
      masterPageName: 'master-layout-light',
      masterPageHtml: masterLayoutX,
      pageContentHtml: pageContentX,
      pageHeaderTags: pageHeaderTags,
    };
  } catch (error) {
    console.error('❌ Error building buildContentContactUs page content:', error);
    return 'Error loading buildContentContactUs page content.';
  }
}
